@if (dates) {
  <div class="theme-{{ theme }}">
    @if (responsive.isDesktop && mode !== "vertical") {
      <div class="grid-list-container horizontal {{ size }}">
        <div
          class="timetable-grid dates mt-4"
          [style.grid-template-columns]="'repeat(' + dates.length + ', 1fr)'"
          [style.grid-auto-rows]="'24px'"
        >
          @for (date of dates; track date; let i = $index) {
            <div class="tile" [class.even]="isEven(i)" [class.odd]="!isEven(i)">
              {{ date | zonedDate: "dayOfWeek" }}&nbsp;
              @if (withDates) {
                <span>{{ date | zonedDate: "dayAndMonth" }}</span>
              }
            </div>
          }
        </div>
        <div
          class="timetable-grid events"
          [style.grid-template-columns]="'repeat(' + dates.length + ', 1fr)'"
          [style.grid-auto-rows]="rowHeight"
        >
          @for (gridItem of gridItems; track gridItem; let i = $index) {
            <div
              class="tile event"
              [class.even]="isEven(i)"
              [class.lastrow]="isLastRow(i)"
              [class.odd]="!isEven(i)"
              [class.top]="i < dates.length"
            >
              @if (gridItem.data) {
                <div>
                  <div class="title">{{ gridItem.data.meeting.title }}</div>
                  <div class="time">
                    {{
                      gridItem.data.startDateTimeInstant
                        | zonedDate: "timeWithoutZone"
                    }}
                    {{ timezone }} -
                    {{ gridItem.data.meeting.durationMinutes }} Mins
                  </div>
                  <div class="teacher">
                    {{ gridItem.data.teacher.firstName }}
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (responsive.isMobile || mode === "vertical") {
      <div class="vertical {{ size }}">
        @for (bucket of dateBuckets; track bucket) {
          @if (bucket.events && bucket.events.length > 0) {
            <div class="grid-list-container">
              <div
                class="timetable-grid dates"
                style="grid-template-columns: repeat(2, 1fr);"
                [style.grid-auto-rows]="rowHeight"
              >
                <div class="tile" style="grid-column: span 2;">
                  {{ bucket.date | zonedDate: "dayOfWeek" }}&nbsp;
                  @if (withDates) {
                    <span>{{ bucket.date | zonedDate: "dayAndMonth" }}</span>
                  }
                </div>
              </div>
              <div
                class="timetable-grid events dates"
                style="grid-template-columns: repeat(2, 1fr);"
                [style.grid-auto-rows]="eventRowHeight"
              >
                @for (ev of bucket.events; track ev; let i = $index) {
                  <div
                    class="tile"
                    [class.even]="isEven(i + 1)"
                    [class.odd]="!isEven(i + 1)"
                  >
                    <div class="event-container">
                      <div class="title">{{ ev.meeting.title }}</div>
                      <div class="time">
                        {{
                          ev.startDateTimeInstant | zonedDate: "timeWithoutZone"
                        }}
                        {{ timezone }} - {{ ev.meeting.durationMinutes }} Mins
                      </div>
                      <div class="teacher">
                        {{ ev.teacher.firstName }}
                      </div>
                    </div>
                  </div>
                }
                @if (!isEven(bucket.events.length)) {
                  <div class="tile even">
                    <div>
                      <div class="title"></div>
                      <div class="time"></div>
                      <div class="teacher"></div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
}
